import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
  

   
    form: {
        display: "grid",
        // backgroundColor:"#fafafa",
        // borderRadius:"20px",
        
        padding:"10px",
        width:"80%",
       
        gridColumnGap:"20px",
      
            gridTemplateColumns: "auto",
       
       
        justifyContent: "center",
        margin:"3% auto",
        alignItems: "center",
        color:"secondry",
        
      
    },
btnBox:{
marginTop:20,
textAlign:"center"




},
box:{
    marginTop:20,
    
}




}));

